import { useQuery } from '@tanstack/react-query';
import React from 'react';

import envVars from '../../../../../constants/envVars';
import useRequest from '../../../../../hooks/useRequest';
import { enrollmentHistoryMock } from '../mockData';
import { ApiEnvelope } from '../../../types';
import { EnrollmentHistoryEntry } from '../types';
import { ENROLLMENT_HISTORY_KEY } from './constants';

const useGetEnrollmentHistory = (member_id: number | null | undefined) => {
    const req = useRequest();

    const request = React.useCallback(() => {
        if (envVars.USE_EHR_MOCK_DATA) {
            return Promise.resolve(enrollmentHistoryMock);
        }

        return req<ApiEnvelope<EnrollmentHistoryEntry[]>>({
            url: `${envVars.API_RTM_HOSTNAME}enterprise/member/${member_id}/enrollment-history/`
        });
    }, [member_id, req]);

    return useQuery({
        queryKey: [ENROLLMENT_HISTORY_KEY, member_id],
        queryFn: request,
        select: (response) => response.data,
        enabled: !!member_id
    });
};

export default useGetEnrollmentHistory;
